import { assign, constant } from "d3plus-common";
import { default as Plot } from "./Plot";
/**
    @class BoxWhisker
    @extends Plot
    @desc Creates a simple box and whisker based on an array of data.
    @example <caption>the equivalent of calling:</caption>
new d3plus.Plot()
  .discrete("x")
  .shape("Box")
*/

var BoxWhisker = function (Plot) {
  function BoxWhisker() {
    var this$1 = this;
    Plot.call(this);
    this._discrete = "x";
    this._shape = constant("Box");
    this.x("x");
    this._tooltipConfig = assign(this._tooltipConfig, {
      title: function title(d, i) {
        if (!d) {
          return "";
        }

        while (d.__d3plus__ && d.data) {
          d = d.data;
          i = d.i;
        }

        if (this$1._label) {
          return this$1._label(d, i);
        }

        var l = this$1._ids(d, i).slice(0, this$1._drawDepth);

        return l[l.length - 1];
      }
    });
  }

  if (Plot) BoxWhisker.__proto__ = Plot;
  BoxWhisker.prototype = Object.create(Plot && Plot.prototype);
  BoxWhisker.prototype.constructor = BoxWhisker;
  return BoxWhisker;
}(Plot);

export default BoxWhisker;